import * as dateFns from 'date-fns';
import id from 'date-fns/locale/id';

type DateFormatType =
  | 'dd MMM yyyy'
  | 'dd MMMM yyyy'
  | 'EEEE, dd MMM yyyy'
  | 'EEEE, dd MMMM yyyy'
  | 'yyyy-MM-ddTHH:mm'
  | 'HH:mm:ss'
  | 'HH:mm';

export const dateFormatter = (date: Date, dateFormat?: DateFormatType) => {
  return dateFns.format(date, dateFormat || 'dd MMMM yyyy', {
    locale: id
  });
};
